import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { FileUploader } from "../../../../components/FileUploader";
import {
  GetServiceCaller,
  PostServiceCaller,
  DeleteServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { useParams } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { Table } from "react-bootstrap";
import { PhoneInput } from "react-international-phone";
import DeleteModal from '../../../../components/DeletePopUpComponent'
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";


const customStyle = {
  // for control
  control: (provided, state) => ({
    ...provided,
    height: "64px",
    overflow: "scroll",
  }),
  //for common cross icon
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "#22ACD3",
      color: "white",
    },
  }),
  //for  dropdown icon
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "0px",
  }),
  //for dropdown conatiner
  indicatorsContainer: (provided, state) => ({
    ...provided,
    width: "28px",
    height: "34px",
    marginTop: "9px",
  }),
};

const EditContractor = () => {


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Contractor"))
  }, [])
  const initialFormData = {
    Title: "",
    FullName: "",
    FirstName: "",
    LastName: "",
    Adharcard: "",
    Pancard: "",
    Role: "",
    Gender: "",
    SkillID: [],
    SubSkillID: [],
    Phone: "",
    Email: "",
    RomPoc: "",
    TotalExp: "",
    RelevantExp: "",
    CurrentEmployment: "",
    Cost: "",
    CurrentLocation: "",
    PreferredLocation: "",
    BillingFrom: "",
    IsInActive:"",
    ReadyForBGV: "",
    Resume: "",
    status: "",
    Remarks: "",
    currency: "",
    Vendor: "",
    Frequency: "",
    lines: [
      {
        LineNo: 1,
        ResName: "",
        ResCost: "",
        ResCurrency: "",
        ResFrequency: "",
        ResRole: "",
        ResTechnology: "",
        ResStartDate: "",
        ResActualEndDate: "",
        ResPayTerm: "",
        ResRemarks: "",
        ResLocation: "",

        SubcontractorID: "",
      },
    ],
  };
  const navigate = useNavigate();
  const { id } = useParams();

  const [subContractorGetData, setSubContractorGetData] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [skillSetOptions, setSkillSetOptions] = useState([]);
  const [subSkillOption, setSubSkillOptions] = useState([]);
  const [subSkillOption1, setSubSkillOptions1] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [technologyListOptions, setTechnologyListOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [romPocOptions, setRomPocOptions] = useState([]);
  const [resNameOptions, setResNameOptions] = useState([]);
  const [jobTitleOptions, setJobTitleOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState(initialFormData);

  const [errors, setErrors] = useState({});


  {
    /* Skill Edit Select code */
  }
  const [skillIdSplit, setSkillIdSplit] = useState([]);
  const [skillNewValue, setSkillNewValue] = useState([]);

  useEffect(() => {
    const mappedSkills = skillIdSplit?.map((element) =>
      skillSetOptions.find((o) => o.value === Number(element))
    );
    setSkillNewValue(mappedSkills);
    setFormData({ ...formData, SkillID: mappedSkills });
  }, [skillIdSplit, skillSetOptions]);



  {
    /* Sub Skill Edit Select code */
  }
  const [subSkillSplit, setSubSkillSplit] = useState([]);
  const [subSkillNewValue, setSubSkillNewValue] = useState([]);

  useEffect(() => {
    const mappedSubSkills = subSkillSplit?.map((element) =>
      subSkillOption1.find((o) => o.value === Number(element))
    );
    setSubSkillNewValue(mappedSubSkills);
    setFormData({ ...formData, SubSkillID: mappedSubSkills });
  }, [subSkillSplit, subSkillOption1]);



  //code to fetch Skill sunskill
  useEffect(() => {
    fetchSkillsId(id);
  }, [id]);


  useEffect(() => {
    if (formData.SkillID && formData.SkillID.length > 0) {
      // Extract the 'value' from each selected option
      const selectedValues = formData.SkillID.map(option => option?.value);

      // Join the selected values into a comma-separated string
      const skillValues = selectedValues.join(',');

      // Fetch sub-skill options with the comma-separated values
      fetchSubSkillOptions(skillValues);
    } else {
      setSubSkillOptions1([]);
    }
  }, [formData.SkillID]); // Dependency array will ensure this effect runs when SkillID changes

  const fetchSubSkillOptions = async (skill_id) => {
    try {
      let data = { skillId: skill_id };
      const response = await PostServiceCaller(
        API_URL + "fetch-subskils",
        data,
        "post"
      );
      const subSkillData = response.data;

      const options = subSkillData.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      // options.push(...formData.SubSkillSet);
      setSubSkillOptions1(options);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };

  // code to Handle Skill
  const [skillValue, setSkillValue] = useState([]);

  const handleSkillChange = async (selectedOptions) => {
    let skill = selectedOptions[selectedOptions.length - 1];

    let skillSetArray = formData.SkillID || [];
    setSkillValue(skillSetArray);
    if (skill?.value) {
      skillSetArray.push(skill);
    }
    setFormData({ ...formData, SkillID: skillSetArray });

    fetchSubSkillOptions(skill?.value);
  };

  // code to handel subSkill

  const fetchSkillsId = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}sub-contractor/${id}`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;

        const skillData = response?.data?.data?.skills;

        const options_skills = skillData.map((skill) => ({
          value: skill.ID,
          label: skill.Name,
        }));
        //fetching subskills
        // const response1 = await PostServiceCaller(API_URL + 'fetch-subskils', {}, 'post');
        const subSkillData = response?.data?.data?.subskills;
        const options_subskills = subSkillData.map((subSkill) => ({
          value: subSkill.ID,
          label: subSkill.SubSkill,
        }));
        //setting skills and subskills
        setSkillSetOptions(options_skills);

        setSubSkillOptions1(options_subskills);

        let skill_selected = [];
        const splitSkillId = cleanedData?.subcontractor?.SkillID?.split(",");
        setSkillIdSplit(splitSkillId);


        //sub skill selecte
        let sub_skill_selected = [];
        const subSkillSplit = cleanedData?.subcontractor?.SubSkillID?.split(",");
        setSubSkillSplit(subSkillSplit);

        const formDataEdit = {
          Title: cleanedData.subcontractor.Title,
          FullName:

            cleanedData.subcontractor.FullName,
          FirstName: cleanedData.subcontractor.FirstName,
          LastName: cleanedData.subcontractor.LastName,
          Adharcard: cleanedData.subcontractor.Adharcard,
          Pancard: cleanedData.subcontractor.Pancard,
          Role: cleanedData.subcontractor.Role,
          Gender: cleanedData.subcontractor.Gender,
          SkillID: skillNewValue,
          SubSkillID: subSkillNewValue,
          Phone: cleanedData.subcontractor?.Phone,
          Email: cleanedData.subcontractor.Email,
          RomPoc: cleanedData.subcontractor.RomPoc,
          TotalExp: cleanedData.subcontractor.TotalExp,
          RelevantExp: cleanedData.subcontractor.RelevantExp,
          CurrentEmployment: cleanedData.subcontractor.CurrentEmployment,
          Cost: cleanedData.subcontractor.Cost,
          CurrentLocation: cleanedData.subcontractor.CurrentLocation,
          PreferredLocation: cleanedData.subcontractor.PreferredLocation,
          BillingFrom: cleanedData.subcontractor.BillingFrom,
          IsInActive: cleanedData.subcontractor.IsInActive,
          ReadyForBGV: cleanedData.subcontractor.ReadyForBGV,
          Resume: cleanedData.subcontractor.Resume,
          status: cleanedData.subcontractor.status,
          currency: cleanedData.subcontractor.currency,
          Vendor: cleanedData.subcontractor.Vendor,
          Remarks: cleanedData.subcontractor.Remarks,
          Frequency: cleanedData.subcontractor.Frequency,
          lines: cleanedData.subcontractorresource.map((ele, index) => ({
            LineNo: ele?.LineNo,
            ResName: ele.ResName,
            ResCost: ele.ResCost,
            ResCurrency: ele.ResCurrency,
            ResFrequency: ele.ResFrequency,
            ResRole: ele.ResRole,
            ResTechnology: ele.ResTechnology,
            ResStartDate: ele.ResStartDate ? moment(ele.ResStartDate).format("DD-MM-YYYY") : '',
            ResEndDate: ele.ResEndDate ? moment(ele.ResEndDate).format("DD-MM-YYYY") : '',
            ResActualEndDate: ele.ResActualEndDate ? moment(ele.ResActualEndDate).format("DD-MM-YYYY") : '',
            ResPayTerm: ele.ResPayTerm,
            ResRemarks: ele.ResRemarks,
            ResLocation: ele.ResLocation,
            SubcontractorID: ele.SubcontractorID,
          })),
        };
        console.log('formDataEdit:: ', formDataEdit);
        
        setFormData(formDataEdit);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Sub-Contrator. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Sub-Contrator:", error);
    }
  };

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}sub-contractor?P_Id=${0}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.data;

        setSubContractorGetData(cleanedData.headers);

        const genderOptions = cleanedData.gender.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setGenderOptions(genderOptions);

        const skillSetOptions = cleanedData.skillset.map((record) => ({
          value: record.ID,
          label: record.Name,
        }));
        setSkillSetOptions(skillSetOptions);

        const subskillOptions = cleanedData.sub_skills.map((record) => ({
          value: record.ID,
          label: record.SubSkill,
        }));
        setSubSkillOptions(subskillOptions);

        const frequencyOptions = cleanedData.frequency.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setFrequencyOptions(frequencyOptions);

        const technologyListOptions = cleanedData.technologylist.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setTechnologyListOptions(technologyListOptions);

        const currencyOptions = cleanedData.currency.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setCurrencyOptions(currencyOptions);

        const romPocOptions = cleanedData.rompoc.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setRomPocOptions(romPocOptions);

        const resNameOptions = cleanedData.resname.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setResNameOptions(resNameOptions);

        const jobTitleOptions = cleanedData.jobtitle.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setJobTitleOptions(jobTitleOptions);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Sub-Contractor. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Sub-Contractor:", error);
    }
  };


  const handleChange = (e, index) => {
    const { name, type, checked, value } = e.target;
    const updatedLines = [...formData.lines];
    const newValue = type === "checkbox" ? checked : value;

    if (name === "RefContact") {
      if (/^\d{0,10}$/.test(value)) {
        updatedLines[index][name] = newValue;
      }
    } else {
      updatedLines[index][name] = newValue;
    }

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };

  const handleAddLine = () => {
    const currentRow =
      formData.lines.length !== 0
        ? formData.lines[formData.lines.length - 1]
        : null;
    const newLineNo = formData.lines.length + 1;
    if (currentRow && currentRow.ResName === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,
        {
          LineNo: newLineNo,
          ResName: "",
          ResCost: "",
          ResCurrency: "",
          ResFrequency: "",
          ResRole: "",
          ResTechnology: "",
          ResStartDate: "",
          ResActualEndDate: "",
          ResPayTerm: "",
          ResRemarks: "",
          ResLocation: "",

          SubcontractorID: "",
        },
      ],
    }));
  };

  const handleSelectChange = (selectedOption, index, name) => {
    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: selectedOption.value,
    };

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));

    // Clear the error for the specific line and field
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[`lines[${index}].${name}`]; // Remove the specific error
      return updatedErrors;
    });
  };


  const handleResDateChange = (event, index) => {
    const { name, value } = event.target;
    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };


  const [fileName, setFileName] = useState();
  const [resumeFile, setResumeFile] = useState([]);
  const handleFile = (file) => {
    if (file) {
      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        Resume: "",
      }));

      // Update form data and resume file state
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        Resume: file,
      }));
      setResumeFile(file);
    } else {
      // Set an error message if file is invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        Resume: "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };

  const [name, setName] = useState("");
  const handleName = (e) => {
    const { name, value } = e.target;
    setName(e.target.value);
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const [phone, setPhone] = useState("");
  const handlePhone = (e) => {
    const value = e.target.value;

    // Ensure the input is an integer and does not exceed 10 digits
    if (/^\d{0,10}$/.test(value)) {
      setPhone(value);
      setFormData({
        ...formData,
        [e.target.name]: value,
      });
    }
  };
  const [email, setEmail] = useState("");
  const handleEmail = (e) => {
    setEmail(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [currentEmp, setCurrentEmp] = useState("");
  const handleCurrentEmpl = (e) => {
    setCurrentEmp(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [currentLocation, setCurrentLocation] = useState("");
  const handleCurentLocation = (e) => {
    setCurrentLocation(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const [remarks, setRemarks] = useState("");
  const handleRemark = (e) => {
    setRemarks(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [contratorType, setContractorType] = useState("");
  const handleContractorType = (e) => {
    setContractorType(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [willimgToTravel, setWillimgToTravel] = useState("");
  const handleWillingToTravel = (e) => {
    setWillimgToTravel(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
 const [IsInActive, setIsInActive] = useState("");
  const handleIsInActive = (e) => {
    setIsInActive(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  const [role, setRole] = useState("");
  const handleRole = (e) => {
    setRole(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [totalExp, setTotalExp] = useState("");
  const handleTotalExp = (e) => {
    setTotalExp(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [prefferedLoc, setPrefferedLoc] = useState("");
  const handlePreferredLoc = (e) => {
    setPrefferedLoc(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [releventExp, setReleventExp] = useState("");
  const handleRelevantExp = (e) => {
    setReleventExp(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [cost, setCost] = useState("");
  const handleCost = (e) => {
    setCost(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [bGV, setBGV] = useState("");
  const handleBGV = (e) => {
    setBGV(e.target.value);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    if (validateForm()) {
      try {
        const response = await PostFormServiceCaller(
          `${API_URL}sub-contractor/${id}`,
          {
            Title: formData.Title,
            // Name: formData.Name,
            FullName: formData.FirstName.concat(" ", formData.LastName),
            FirstName: formData.FirstName,
            LastName: formData.LastName,
            Adharcard: formData.Adharcard,
            Role: formData.Role,
            Gender: formData.Gender,
            SkillID: formData.SkillID,
            SubSkillID: formData.SubSkillID,
            Phone: formData.Phone,
            Email: formData.Email,
            RomPoc: formData.RomPoc,
            TotalExp: formData.TotalExp,
            RelevantExp: formData.RelevantExp,
            CurrentEmployment: formData.CurrentEmployment,
            Cost: formData.Cost,
            CurrentLocation: formData.CurrentLocation,
            PreferredLocation: formData.PreferredLocation,
            BillingFrom: formData.BillingFrom,
            IsInActive: formData.IsInActive,
            ReadyForBGV: formData.ReadyForBGV,
            Resume: formData.Resume,
            status: formData.status,
            Remarks: formData?.Remarks,
            currency: formData.currency,
            Vendor: formData.Vendor,
            Pancard: formData.Pancard,
            Frequency: formData.Frequency,
            lines: formData?.lines,
          },
          "put"
        );
        setLoading(false);
        if (response.status === 200) {
          toast.success("Data submitted successfully");
          // setFormData(initialFormData);
          setTimeout(() => {
            window.location.href = "/contractors";
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error while submitting data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.error("Server responded with status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);

    }

  };

  const [rompocValue, setRomPocValue] = useState();

  const [genderValue, setGenderValue] = useState();

  useEffect(() => {
    setFormData({ ...formData, Gender: genderValue });
  }, [genderValue]);
  const [currency, setCurrency] = useState();
  const [frequency, setFrequency] = useState();

  const validateForm = () => {
    const newErrors = {};

    // Validate top-level fields
    if (!formData.FirstName) newErrors.FirstName = "First Name is required";
    if (!formData.LastName) newErrors.LastName = "Last Name is required";
    if (!formData.SkillID) newErrors.SkillID = "Skill's is required";
    if (!formData.Cost) newErrors.Cost = "Cost is required";
    if (!formData.Email) newErrors.Email = "Email is required";
    if (!formData.TotalExp) newErrors.TotalExp = "TotalExp is required";

    // Validate each line entry for resname and resCurrency with index
    // if (formData.lines && Array.isArray(formData.lines)) {
    //   formData.lines.forEach((line, index) => {
    //     if (line.ResName === undefined || line.ResName === null || line.ResName === "") {
    //       newErrors[`lines[${index}].ResName`] = "Client Name is required";
    //     }
    //     if (line.ResCurrency === undefined || line.ResCurrency === null || line.ResCurrency === "") {
    //       newErrors[`lines[${index}].ResCurrency`] = "Currency is required";
    //     }
    //   });
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleDeleteLine = async (index, SubcontID, LineNo) => {

    try {
      // for Line Delete
      await DeleteServiceCaller(
        `${API_URL}sub-contractor-delete/${SubcontID}/${LineNo}`,
        {},
        "delete"
      );
      const updatedLines = formData.lines.filter((_, i) => i !== index);
      setFormData({ ...formData, lines: updatedLines });
    } catch (error) {
      console.error("There was an error deleting the line!", error);
    }
  };

  const [fname, setFName] = useState("");
  const handleFName = (e) => {
    const { name, value } = e.target;
    setFName(e.target.value);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [lname, setLName] = useState("");
  const handleLName = (e) => {
    const { name, value } = e.target;
    setLName(e.target.value);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [aadhar, setAadhar] = useState("");
  const handleAadhar = (e) => {
    const { name, value } = e.target;

    // Always update the value so the user can type
    setAadhar(value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Validate Aadhar number
    let isValid = true;
    if (name === "Adharcard") {
      isValid = /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/.test(value);
    }

    // Set errors based on validity
    if (isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the error if valid
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Invalid Aadhar Number", // Show error if invalid
      }));
    }
  };


  const [pancard, setPanCard] = useState("");
  const handlePanCard = (e) => {
    const { name, value } = e.target;
    setPanCard(e.target.value);
    setFormData({
      ...formData,
      [name]: value,
    });

    let isValid = true;
    if (name === "Pancard") {
      isValid = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(value);
    }

    // Set errors based on validity
    if (isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the error if valid
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Invalid Pan card Number", // Show error if invalid
      }));
    }
  };





  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);


  const openDeleteModal = (item) => {

    setShowDeleteModal(true);
    setSelectedDeleteItem(item);

  };


  const handleModalDelete = () => {
    if (selectedDeleteItem) {

      handleDeleteProjectLine(selectedDeleteItem.index, selectedDeleteItem.SubcontractorID, selectedDeleteItem.LineNo);

      setShowDeleteModal(false);
      setSelectedDeleteItem(null);

    }
  };
  const handleDeleteProjectLine = async (index, SubcontractorID, LineNo) => {

    try {
      // for Line Delete
      await DeleteServiceCaller(
        `${API_URL}sub-contractor-delete/${SubcontractorID}/${LineNo}`,
        {},
        "delete"
      );
      const updatedLines = formData.lines.filter((_, i) => i !== index);
      setFormData({ ...formData, lines: updatedLines });
    } catch (error) {
      console.error("There was an error deleting the line!", error);
    }
  };
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  };

  return (
    <>

      <div className="Container">
        <form
          id="formOne"
          className="rounded bg-white mt-2"
        // onSubmit={handleSubmit}
        >
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="contractorDetails-tab"
                data-bs-toggle="tab"
                data-bs-target="#contractorDetails"
                type="button"
                role="tab"
                aria-controls="contractorDetails"
                aria-selected="true"
              >
                Contractor Details<span className="text-Primary">{formData.FirstName?.trim() && `: ${formData.FirstName}`}</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="addProject-tab"
                data-bs-toggle="tab"
                data-bs-target="#addProject"
                type="button"
                role="tab"
                aria-controls="addProject"
                aria-selected="false"
              >
                Add Project
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="contractorDetails"
              role="tabpanel"
              aria-labelledby="contractorDetails-tab"
            >
              <div className="card-body mx-2">
                <div className="row row-flex p-2">
                  {/* grid one */}
                  <div className="col-md-12 flex-col mt-1">
                    <div className=" ">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <label class="form-label">
                            Type <span className="text-danger me-2">*</span>
                          </label>
                          <input
                            type="radio"
                            className={`form-check-input me-2 ${errors.Title ? "is-invalid" : ""
                              }`}
                            name="Title"
                            onChange={handleContractorType}
                            value="FreeLancer"
                            checked={
                              formData.Title == "FreeLancer" ? true : false
                            }
                          />
                          <span className="me-2">FreeLancer</span>
                          <input
                            type="radio"
                            className={`form-check-input me-2 ${errors.Title ? "is-invalid" : ""
                              }`} name="Title"
                            onChange={handleContractorType}
                            value="SubContractor"
                            checked={
                              formData.Title == "SubContractor"
                                ? true
                                : false
                            }
                          />
                          <span>SubContractor</span>   {errors.Title && (
                            <div className="invalid-feedback">
                              {errors.Title}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-3">
                          <label className="form-label">
                            First Name
                            <span className="text-danger me-2">*</span>
                          </label>

                          <input
                            name="FirstName"
                            type="text"
                            className={`form-control ${errors.FirstName ? "is-invalid" : ""
                              }`}
                            id="FirstName"
                            value={formData.FirstName}
                            onChange={(e) => handleFName(e)}
                          />
                        </div>{errors.FirstName && (
                          <div className="invalid-feedback">
                            {errors.FirstName}
                          </div>
                        )}
                        <div className="col-md-3">
                          <label className="form-label">
                            Last Name
                            <span className="text-danger me-2">*</span>
                          </label>

                          <input
                            name="LastName"
                            type="text"
                            className={`form-control ${errors.LastName ? "is-invalid" : ""
                              }`}
                            id="LastName"
                            value={formData.LastName}
                            onChange={(e) => handleLName(e)}
                          /> {errors.LastName && (
                            <div className="invalid-feedback">
                              {errors.LastName}
                            </div>
                          )}
                        </div>
                        <div className="col-sm-3">
                          <label class="form-label">
                            Gender

                          </label>
                          <Select
                            name="gender"
                            onChange={(gender) =>
                              setGenderValue(gender.value)
                            }
                            class="form-control"
                            options={genderOptions}
                            value={genderOptions.find(
                              (option) => option.value == formData.Gender
                            )}
                          />
                        </div>
                        <div className="col-sm-3">
                          <label class="form-label">
                            Contact No.

                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Phone"
                            onChange={handlePhone}
                            value={formData.Phone}
                          />

                          {/* <input
                              // defaultCountry="in"
                              className="form-control"
                              // rules={{ required: true }}
                              value={formData?.Phone}
                              onChange={(phone) => setFormData({ ...formData, Phone: phone })}
                            /> */}
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-3">
                          <label class="form-label">
                            Email ID
                            <span className="text-danger me-2">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${errors.Email ? "is-invalid" : ""
                              }`}
                            name="Email"
                            onChange={handleEmail}
                            value={formData.Email}
                          />{errors.Email && (
                            <div className="invalid-feedback">
                              {errors.Email}
                            </div>
                          )}
                        </div>

                        <div className="col-sm-3">
                          <label class="form-label">
                            Current Location
                          </label>
                          <input
                            type="text"
                            className="form-control "
                            name="CurrentLocation"
                            onChange={handleCurentLocation}
                            value={formData.CurrentLocation}
                          />
                        </div>
                        <div className="col-md-3">
                          <label class="form-label">
                            Preferred Location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="PreferredLocation"
                            onChange={handlePreferredLoc}
                            value={formData.PreferredLocation}
                          />
                        </div>
                        <div class="col-sm-3">
                          <label class="form-label">Role</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Role"
                            onChange={handleRole}
                            value={formData.Role}
                          />
                        </div>

                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-3">
                          <label class="form-label">Current Emp. </label>
                          <input
                            type="number"
                            className="form-control text-end"
                            name="CurrentEmployment"
                            onChange={handleCurrentEmpl}
                            value={formData.CurrentEmployment}
                            placeholder="in Years"
                          />
                        </div>
                        <div className="col-md-3 d-flex">
                          <div className="d-flex flex-column">
                            <label className="form-label">
                              Experience<span className="text-danger me-2">*</span>
                            </label>
                            <div className="row">
                              <div className="col-md-6">

                                <input
                                  type="text"
                                  className={`form-control text-end${errors.TotalExp ? "is-invalid" : ""
                                    }`}
                                  name="TotalExp"
                                  onChange={handleTotalExp}
                                  value={formData.TotalExp}
                                />
                                {errors.TotalExp && (
                                  <div className="invalid-feedback">
                                    {errors.TotalExp}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-6">

                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="RelevantExp"
                                  onChange={handleRelevantExp}
                                  value={formData.RelevantExp}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">
                            Cost <span className="text-danger me-2">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control text-end ${errors.Cost ? "is-invalid" : ""
                              }`}
                            name="Cost"
                            onChange={handleCost}
                            value={formData.Cost}
                          />
                          {errors.Cost && (
                            <div className="invalid-feedback">
                              {errors.Cost}
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label class="form-label">Frequency</label>
                          <Select
                            name="Frequency"
                            onChange={(frequency) => {
                              setFrequency(frequency.value);
                              setFormData({
                                ...formData,
                                Frequency: frequency.value,
                              });
                            }}
                            value={frequencyOptions.find(
                              (option) =>
                                option.value === formData.Frequency
                            )}
                            class="form-control text-end"
                            options={frequencyOptions}
                          />
                        </div>

                      </div>
                      <div className="row">


                        <div class="col-md-3">
                          <label class="form-label">RMG POC</label>
                          <Select
                            name="RomPoc"
                            onChange={(rompoc) => {
                              setRomPocValue(rompoc.value);
                              setFormData({
                                ...formData,
                                RomPoc: rompoc.value,
                              });
                            }}
                            value={romPocOptions.find(
                              (option) =>
                                option.value == Number(formData.RomPoc)
                            )}
                            // className="form-control"
                            options={romPocOptions}
                          />
                        </div>
                        <div className="col-md-3">
                          <label class="form-label">Currency</label>
                          <Select
                            name="currency"

                            onChange={(currency) => {
                              setCurrency(currency.value);
                              setFormData({
                                ...formData,
                                currency: currency.value,
                              });
                            }}

                            value={currencyOptions.find(
                              (option) => option.value == formData.currency
                            )}
                            class="form-control text-end"
                            options={currencyOptions}
                          />
                        </div>

                        <div className="col-md-3">
                          <label className="form-label">Aadhar No.</label>
                          <input type="text" name="Adharcard" placeholder="Eg: 0000 0000 0000" className={`form-control ${errors.Adharcard ? 'is-invalid' : ''}`} value={formData.Adharcard} onChange={(e) => handleAadhar(e)} />
                          {errors.Adharcard && (
                            <div className="invalid-feedback">
                              {errors.Adharcard}
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">PAN No.</label>
                          <input type="text" name="Pancard" placeholder="Eg: AAAAA9999A" className={`form-control ${errors.Pancard ? 'is-invalid' : ''}`} value={formData.Pancard} onChange={(e) => handlePanCard(e)} />
                          {errors.Pancard && (
                            <div className="invalid-feedback">
                              {errors.Pancard}
                            </div>
                          )}
                        </div>


                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-3">
                          <label class="form-label">Skill<span className="text-danger me-2">*</span></label>
                          <Select
                            menuShouldScrollIntoView={true}
                            isMulti
                            name="SkillID"
                            value={formData.SkillID}

                            options={skillSetOptions}
                            className={`basic-multi-select ${errors.SkillID ? "is-invalid" : ""
                              }`}
                            styles={customStyle}
                            classNamePrefix="select"
                            onChange={(selectedOptions) =>
                              setFormData({
                                ...formData,
                                SkillID: [...selectedOptions],
                              })
                            }
                          />

                          {errors.SkillID && (
                            <div className="invalid-feedback">
                              {errors.SkillID}
                            </div>
                          )}
                        </div>
                        <div className="col-sm-3">
                          <label class="form-label">SubSkill</label>
                          <Select
                            isMulti
                            name="SubSkillID"
                            id="subskillSelect"
                            options={subSkillOption1}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={formData.SubSkillID}
                            onChange={(selectedOptions) =>
                              setFormData({
                                ...formData,
                                SubSkillID: [...selectedOptions],
                              })
                            }
                            styles={customStyle}
                          />
                        </div>
                        <div className="col-md-3 ">
                          <label class="form-label">Remark</label>
                          <textarea
                            placeholder="Remark"
                            className="form-control"
                            name="Remarks"
                            onChange={handleRemark}
                            value={formData.Remarks}
                          ></textarea>
                        </div>

                        <div className="col-md-3 mt-4">
                          <label class="form-label">Ready For BGV. </label>
                          <div className="ms-2">
                            <input
                              type="radio"
                              className="form-check-input me-2"
                              name="ReadyForBGV"
                              onChange={handleBGV}
                              checked={
                                formData.ReadyForBGV == 0
                              }
                              value="0"
                            />
                            <span className="me-2">Yes</span>
                            <input
                              type="radio"
                              className="form-check-input me-2"
                              name="ReadyForBGV"
                              checked={
                                formData.ReadyForBGV == 1
                              }
                              onChange={handleBGV}
                              value="1"
                            />
                            <span>No</span>
                          </div>
                        </div>

                      </div>
                      <div className="row mt-2">
                        <div className="col-md-3 mt-4">
                          <label class="form-label">
                            Willing To Travel
                          </label>
                          <div className="ms-2">
                            <input
                              type="radio"
                              className="form-check-input me-2"
                              name="BillingFrom"
                              checked={
                                formData.BillingFrom == "1" || 1
                                  ? true
                                  : false
                              }
                              onChange={handleWillingToTravel}
                              value="1"
                            />
                            <span className="me-2">Yes</span>
                            <input
                              type="radio"
                              className="form-check-input me-2"
                              name="BillingFrom"
                              checked={
                                formData.BillingFrom == "0" || 0
                                  ? true
                                  : false
                              }
                              onChange={handleWillingToTravel}
                              value="0"
                            />
                            <span>No</span>
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <label className="form-label">
                            Resume
                            <span className="text-danger me-2">*</span>
                          </label>
                          <div className="">
                            <FileUploader handleFile={handleFile} />


                            {formData.Resume || fileName ? (
                              <p>
                                Resume:{" "}
                                <a
                                  target="_blank"
                                  href={
                                    formData.Resume
                                  }
                                >
                                  {fileName ? fileName : formData.Resume}
                                </a>
                              </p>
                            ) : null}

                          </div>
                        </div>
                         <div className="col-md-3 mt-4">
                          <label class="form-label">
                            Active
                          </label>
                          <div className="ms-2">
                            <input
                              type="radio"
                              className="form-check-input me-2"
                              name="IsInActive"
                              checked={formData.IsInActive == "0" ? true : false}
                              onChange={handleIsInActive}
                              value="0"
                            />
                            <span className="me-2">Yes</span>
                            <input
                              type="radio"
                              className="form-check-input me-2"
                              name="IsInActive"
                              checked={
                                formData.IsInActive == "1"
                                  ? true
                                  : false
                              }
                              onChange={handleIsInActive}
                              value="1"
                            />
                            <span>No</span>
                          </div>
                        </div>
                      </div>
                      <div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/** Add project Code Start */}

            <div
              className="tab-pane fade"
              id="addProject"
              role="tabpanel"
              aria-labelledby="addProject-tab"
            >
              <div
                className="mt-2 mb-3"
                style={{ zIndex: "-999 !important" }}
              >
                <div className=" ">
                  <div className="">
                    <div className="table-responsive poc-head rounded px-2">
                      <button
                        type="button"
                        onClick={handleAddLine}
                        className="custom-btn-sm pull-right mb-1"
                      >
                        <i class="fa fa-plus"></i>&nbsp;Add
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <div className="table-responsive poc-head rounded">
                      <Table
                        style={{ background: "#ECECEC !important" }}
                        // id="poctable_head"
                        className="table table-bordered"
                      >
                        <thead id="thcolor" className="text-center">
                          <tr rowspan="2">
                            <th className="align-middle">Sr. No.</th>
                            <th
                              className="border-1 px-0 
                            fs-10"
                            >
                              <div className="border-1 border-bottom">
                                Client Name{" "}
                              </div>
                              <div>Start Date</div>
                            </th>

                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                PO Cost
                              </div>
                              <div>End Date</div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Frequency
                              </div>
                              <div>Actual End Date </div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Currency
                              </div>
                              <div>Pay Term</div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Role
                              </div>
                              <div>Remark</div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Technology
                              </div>
                              <div>Location</div>
                            </th>
                            <th className="align-middle fs-9">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.lines.map((line, index) => (
                            <tr key={index} className="bg-white" rowspan="2">
                              <td>{index + 1}</td>
                              <td>
                                <div>
                                  <Select
                                    name="ResName"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResName"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    menuPlacement="top"
                                    value={resNameOptions.find(
                                      (option) =>
                                        option.value == Number(line.ResName)
                                    )}
                                    // className={` ${errors?.[`lines[${index}].ResName`]
                                    //   ? "is-invalid"
                                    //   : ""
                                    //   }`}
                                    options={resNameOptions}
                                  />
                                  {/* {errors?.[`lines[${index}].ResName`] ? <span className="error">
                                    {errors?.[`lines[${index}].ResName`]}
                                  </span> : ''} */}
                                </div>
                                <div className="mt-1">
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResDateChange(e, index)
                                    }
                                    name="ResStartDate"
                                    id="ResStartDate"
                                    className="form-control"
                                    value={line.ResStartDate}
                                    placeholderText="DD-MM-YYYY"
                                  />
                                </div>
                              </td>

                              <td>
                                <div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResCost"
                                    value={line.ResCost}
                                    onChange={(e) => handleChange(e, index)}
                                  />
                                </div>
                                <div className="mt-1">
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResDateChange(e, index)
                                    }
                                    name="ResEndDate"
                                    id="ResEndDate"
                                    className="form-control"
                                    value={line.ResEndDate}
                                    placeholderText="DD-MM-YYYY"
                                    // minDate={new Date(line.ResStartDate)}
                                    minDate={new Date(moment(line.ResStartDate).format("DD-MM-YYYY"))}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResFrequency"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResFrequency"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    menuPlacement="top"
                                    value={frequencyOptions.find(
                                      (option) =>
                                        option.value === line.ResFrequency
                                    )}
                                    // className="form-control"
                                    options={frequencyOptions}
                                  />
                                </div>
                                <div className="mt-1">
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResDateChange(e, index)
                                    }
                                    name="ResActualEndDate"
                                    id="ResActualEndDate"
                                    className="form-control"
                                    value={line.ResActualEndDate}
                                    placeholderText="DD-MM-YYYY"
                                    minDate={new Date(moment(line.ResStartDate).format("DD-MM-YYYY"))}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResCurrency"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResCurrency"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    menuPlacement="top"
                                    value={currencyOptions.find(
                                      (option) =>
                                        option.value === line.ResCurrency
                                    )}
                                    // className="form-control"
                                    // className={` ${errors?.[`lines[${index}].ResCurrency`]
                                    //   ? "is-invalid"
                                    //   : ""
                                    //   }`}
                                    options={currencyOptions}
                                  />
                                  {/* {errors?.[`lines[${index}].ResCurrency`] ? <span className="error">
                                    {errors?.[`lines[${index}].ResCurrency`]}
                                  </span> : ''} */}
                                </div>
                                <div className="mt-1">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResPayTerm"
                                    onChange={(e) => handleChange(e, index)}
                                    value={line.ResPayTerm}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResRole"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResRole"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    menuPlacement="top"
                                    value={jobTitleOptions.find(
                                      (option) =>
                                        option.value === line.ResRole
                                    )}
                                    // className="form-control"
                                    options={jobTitleOptions}
                                  />
                                </div>
                                <div className="mt-1">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResRemarks"
                                    onChange={(e) => handleChange(e, index)}
                                    value={line.ResRemarks}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResTechnology"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResTechnology"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    menuPlacement="top"
                                    value={technologyListOptions.find(
                                      (option) =>
                                        option.value === line.ResTechnology
                                    )}
                                    // className="form-control"
                                    options={technologyListOptions}
                                  />
                                </div>
                                <div className="mt-1">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResLocation"
                                    onChange={(e) => handleChange(e, index)}
                                    value={line.ResLocation}
                                  />
                                </div>
                              </td>
                              <td className="text-center align-middle">
                                <div
                                  type="button"
                                  // onClick={() =>
                                  //   handleDeleteLine(
                                  //     index,
                                  //     line.SubcontractorID,
                                  //     line.LineNo
                                  //   )
                                  // }
                                  onClick={() => openDeleteModal({ index, SubcontractorID: line.SubcontractorID, LineNo: line.LineNo })}
                                >
                                  <i
                                    className="bi bi-trash text-center"
                                    style={{ fontSize: "1.2rem" }}
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
              {/** Add project Code End */}

            </div>
          </div>
          <div className="text-end">
            <button
              type="button"
              className="cancel-btn me-2"
              onClick={() => {
                navigate("/contractors");
              }}
            >
              Cancel
            </button>
            <button
              disabled={loading ? true : false}
              type="button"
              className="custom-btn me-2"
              onClick={handleSubmit}
            >
              {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
            </button>
          </div>
        </form>
      </div>

      <DeleteModal
        show={showDeleteModal}
        onClose={handleDeleteClose}
        onConfirm={handleModalDelete}
        message="Are you sure you want to delete this item?"
      />

    </>
  );
};

export default EditContractor;
